module.exports = __webpack_public_path__ + "img/green_2048.792662ce.png";